export enum CategoryId {
OBJECT_PART = 1,
OBJECT_TYPE = 2,
TIPUS = 3,
PERIOD_ISRAEL = 4,
EXPEDITION = 5,
PERIOD_OVERSEAS = 6,
SHALIT = 7,
TAT_SHALIT = 8,
MATERIAL = 9,
TECHNIQUE = 10,
COPY = 17,
LANGUAGE = 18,
WRITING = 19,
KITZUR = 20,
TAT_CHIBUR = 21,
SUGA = 22,
MANUSCRIPT_TYPE = 23,
CHIBUR_TYPE = 24,
ARICH = 14,
TVIAT_RECHEV = 15,
KEYWORDS = 12,
MITBAAH = 13,
CHIBUR = 16,

}